"use client"; // Mark this as a client component

import { AuthProvider } from "@/context/AuthContext";
import { QueryProvider } from "@/providers/QueryProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { SidebarProvider } from "@/components/ui/sidebar";

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider defaultTheme="light" storageKey="app-theme">
      <QueryProvider>
        <AuthProvider>
            {children}
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
